import { t } from 'i18next';
import * as yup from 'yup';

export const corporatePartAssignVendorSchema = (isAlternateVersionEnabled = false) => {
  const baseSchema = yup.object().shape({
    vendorName: yup.string().label(t('labelVendorName')).nullable(),
    vendorId: yup
      .string()
      .label(isAlternateVersionEnabled ? t('labelSupplierNumber') : t('labelVendorId'))
      .nullable(),
  });

  if (!isAlternateVersionEnabled) {
    return baseSchema;
  }

  if (isAlternateVersionEnabled) {
    baseSchema.shape({
      vendorLocation: yup.object().label(t('labelVendor')).nullable(),
      accountsPayableId: yup.string().label(t('labelAPNumber')).nullable(),
    });
  }

  return baseSchema;
};
